// ----------------------------------------------------------------------
// <copyright file="Izenda.CategoryPermission.jsx" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

!(function () {
  var React = require('react');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var CommonTree = require('share/components/controls/CommonTree/Izenda.CommonTree');
  var connect = require('share/enhancers/Izenda.Connect');
  var action = require('./Izenda.CategoryPermissionAction');

  var CategoryPermission = function (props) {
    return (
      <div className="izenda-CategoryPermission">
        <GridLayout className="u-posRelative u_fullHeight">
          <GridLayout.Row className="u_fullHeight">
            <GridLayout.Col cols={4} className="u_fullHeight">
              <div className="u_fullSize">
                <CommonTree
                  header={props.leftHeader}
                  nodes={props.leftTree}
                  filter={props.leftTreeFilter}
                  readOnly={props.readOnly}/>
              </div>
            </GridLayout.Col>
            <div className="u-posAbsolute izenda-CategoryPermission-ControllArrow izenda-CategoryPermission-Available_Visible">
              <div onClick={!props.readOnly && props.fromLeftToMiddle}>
                <i className="icon-right-open" />
              </div>
              <div onClick={!props.readOnly && props.fromMiddleToLeft}>
                <i className="icon-left-open" />
              </div>
            </div>
            <GridLayout.Col cols={4} className="u_fullHeight">
              <div className="u_fullSize">
                <CommonTree
                  header={props.middleHeader}
                  nodes={props.middleTree}
                  filter={props.middleTreeFilter}
                  readOnly={props.readOnly}/>
              </div>
            </GridLayout.Col>
            <div className="u-posAbsolute izenda-CategoryPermission-ControllArrow izenda-CategoryPermission-Visible_Save">
              <div onClick={!props.readOnly && props.fromMiddleToRight}>
                <i className="icon-right-open" />
              </div>
              <div onClick={!props.readOnly && props.fromRightToMiddle}>
                <i className="icon-left-open" />
              </div>
            </div>
            <GridLayout.Col cols={4} className="u_fullHeight">
              <div className="u_fullSize">
                <CommonTree
                  header={props.rightHeader}
                  nodes={props.rightTree}
                  filter={props.rightTreeFilter}
                  readOnly={props.readOnly} />
              </div>
            </GridLayout.Col>
          </GridLayout.Row>
        </GridLayout>
      </div>
    );
  };

  module.exports = connect(action)(CategoryPermission);
} ());



// WEBPACK FOOTER //
// ./ui/modules/Settings/PermissionTab/PermissionBody/Izenda.CategoryPermission.jsx